import { Model as e } from "../../../model.js";
class r extends e {
  constructor(s) {
    super(), this.status = s.status, this.delivery = s.delivery, this.pos = s.pos, this.payment = s.payment, this.refund = s.refund;
  }
}
export {
  r as TicketHistoryModel
};
//# sourceMappingURL=ticketHistory.model.js.map
